export * from './lib/app-client-shared-components-chat-feature.module';

export * from './lib/app-client-shared-components-chat-feature.component';
